<template>
    <div class="modal-content">
        <h1 class="text-center">{{$t('global.login')}}</h1>
        <div class="columns">
            <div class="column is-12">
                <label class="label" for="password">{{$t('modal-landing.modalLandingPassword')}}</label>
                <div class="control">
                    <input type="password" id="password" class="input" v-model="password" autofocus @keyup="keyPress" ref="pwd">
                </div>
                <p v-show="errorPassword" class="error">{{$t('modal-landing.modalLandingWrongPassword')}}</p>
            </div>
        </div>
        <div class="text-center buttons-modal">
            <a @click="validateLogin()" class="button primary">{{$t('global.login')}}</a>
            <a @click="closeModal()" class="button">{{$t('global.cancel')}}</a>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import sha256 from 'crypto-js/sha256'

export default {
  name: 'login-modal',
  data () {
    return {
      password: '',
      correctPassword: '585bb942e6c79644608c60de457025436da9ee53a1f7cdae089f6b06e3e9b8b4',
      errorPassword: false
    }
  },
  computed: {
    ...mapGetters({
      showModal: 'getShowModal',
      modalType: 'getModalType'
    })
  },
  methods: {
    ...mapActions({
      setShowModal: 'setShowModal',
      setModalType: 'setModalType',
      setActivePageCode: 'setActivePageCode'
    }),
    closeModal () {
      this.setShowModal(false)
      this.setModalType(null)
    },
    keyPress (key) {
      if (key.key === 'Enter') {
        this.validateLogin()
      }
    },
    validateLogin () {
      this.errorPassword = false
      if (this.password.trim() !== '') {
        if (sha256(this.password.trim()).toString() === this.correctPassword) {
          this.closeModal()
          this.setActivePageCode('project')
        } else {
          this.errorPassword = true
        }
      }
    }
  },
  mounted () {
    this.$refs.pwd.focus()
  }
}
</script>
